import { DepartmentDto } from "@/models/planning/DepartmentDto";
import client  from "@/clients/PlanningClient";

const resource = '/departments';

export const DepartmentRepository = {
  getAll() {
    return client.get(resource) as Promise<DepartmentDto[]>;
  }
}